module.exports = __webpack_public_path__ + "static/media/20-point-player.9edd3839.png";